import React, { PureComponent, RefObject, createRef } from 'react';
import { noop } from 'lodash';

import { TweetMetadata } from 'api';
import { EmbedPlaceholder, EmbedWrapper } from './';

interface IProps {
  id: TweetMetadata['id_str'];
}

interface IState {
  loaded: boolean;
}

const EMBED_MAX_WIDTH = 520;

class EmbedTwitter extends PureComponent<IProps, IState> {
  container: RefObject<HTMLDivElement>;

  state: IState = {
    loaded: false,
  };

  constructor(props: IProps) {
    super(props);
    this.container = createRef();
  }

  componentDidMount() {
    this.loadTweet();
  }

  getTwitter() {
    return window.twttr && window.twttr.widgets && window.twttr.widgets;
  }

  onLoaded = () => {
    this.setState({ loaded: true });
  };

  loadTweet = () => {
    const { id } = this.props;
    const { current } = this.container;

    this.getTwitter() &&
      this.getTwitter()
        .createTweet(id, current, { align: 'center', width: EMBED_MAX_WIDTH })
        .then(this.onLoaded)
        .catch(noop);
  };

  render() {
    const { loaded } = this.state;

    return (
      <div>
        {!loaded && <EmbedPlaceholder />}
        <EmbedWrapper visible={loaded}>
          <div ref={this.container} />
        </EmbedWrapper>
      </div>
    );
  }
}

export default EmbedTwitter;
